import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { StaggeringData } from "@/app/alts/unlisted-shares/[...id]/page-client";
import { formatIndianCurrency } from "@/app/utils/helper";

interface StaggeringPriceProps {
    pricingTiers: StaggeringData[];
    onClose: (value: boolean) => void;
}

const StaggeringPrice: React.FC<StaggeringPriceProps> = ({ pricingTiers, onClose }) => {
    return (
        <Dialog open={true} onOpenChange={onClose}>
            <DialogContent className="w-[90%] rounded-2xl md:w-[660px] z-50">
                <VisuallyHidden.Root>
                    <DialogTitle>Staggering Prices Modal</DialogTitle>
                </VisuallyHidden.Root>
                <div className="w-full">
                    <div className="flex flex-col items-center">
                        <div className="mx-auto max-w-lg">
                            <div className="mx-auto max-w-3xl pt-s14 md:px-s12 md:pb-s12">
                                <h2 className="mb-8 text-center text-lg font-bold leading-tight md:text-3xl">
                                    Get additional discount on purchasing higher number of units
                                </h2>

                                <div className="overflow-hidden border">
                                    <div className="grid grid-cols-2 bg-[#F85B2C] text-center font-bold text-white">
                                        <div className="p-4 text-lg">Quantity</div>
                                        <div className="p-4 text-lg">Rate/Share</div>
                                    </div>

                                    {pricingTiers &&
                                        pricingTiers.map((tier, index) => (
                                            <div key={index} className="grid grid-cols-2 border-t">
                                                <div className="p-4 text-center text-md font-bold">
                                                    {tier.qty}
                                                </div>
                                                <div className="p-4 text-center text-md font-bold">
                                                    {formatIndianCurrency(tier.price)}
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default StaggeringPrice;
